// extracted by mini-css-extract-plugin
module.exports = {"appdefsResources":"style__appdefsResources__I3SkT"};